module.exports = __webpack_public_path__ + "img/23.0175293c.png";